module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("component-card-" + _vm.columns)
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row align-middle"
  }, [(_vm.showBullets) ? _c('div', {
    staticClass: "columns shrink align-self-middle"
  }, [_vm._t("actionBullets")], 2) : _vm._e(), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.columns), function(n) {
    return _c('div', {
      staticClass: "columns align-self-middle",
      class: {
        'shrink': _vm.shouldShrink('n' + n)
      }
    }, [_vm._t('n' + n)], 2)
  }), 0)]), (_vm.showAction) ? _c('div', {
    staticClass: "columns shrink align-self-middle"
  }, [_vm._t("actionPage")], 2) : _vm._e()]), _c('div', {
    staticClass: "row"
  }, [_vm._t("bottom")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-be7fcca6!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/CardN.vue
// module id = 2510
// module chunks = 1